import React from 'react';
import axios from 'axios';

import * as Globals from './../Globals';


export default class GradingSystems extends React.Component {

    constructor() {
        super();

        this.currentPassedSystemLimit = 50;
        this.currentSchoolSystemLimits = [];
        this.currentAwardSystemLimits = [];
        
        this.state = {
            passedSystemLimit: 50,
            schoolSystemLimits: [],
            awardSystemLimits: []
        }

    }

    componentWillMount() {
        this.getPassedSystem();
        this.getAwardSystem();
        this.getSchoolSystem();
    }

    getPassedSystem() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + "grading_system/passed_system?Authentication=" + cookie
        ).then(response => {
            this.currentPassedSystemLimit = parseInt(response.data.records[0].percentage, 10);
            this.setState({
                passedSystemLimit: parseInt(response.data.records[0].percentage, 10)
            });
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    getAwardSystem() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + "grading_system/grading_passed_system?Authentication=" + cookie,
        ).then(response => {
            this.currentAwardSystemLimits = [
                parseInt(response.data.records[0].percentage_3, 10),
                parseInt(response.data.records[0].percentage_2, 10),
                parseInt(response.data.records[0].percentage_1, 10)
            ];
            this.setState({
                awardSystemLimits: [
                    parseInt(response.data.records[0].percentage_3, 10),
                    parseInt(response.data.records[0].percentage_2, 10),
                    parseInt(response.data.records[0].percentage_1, 10)
                ]
            });
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    getSchoolSystem() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + "grading_system/percentage_system?Authentication=" + cookie,
        ).then(response => {
            this.currentSchoolSystemLimits = [
                parseInt(response.data.records[0].percentage_4, 10),
                parseInt(response.data.records[0].percentage_3, 10),
                parseInt(response.data.records[0].percentage_2, 10),
                parseInt(response.data.records[0].percentage_1, 10)
            ];
            this.setState({
                schoolSystemLimits: [
                    parseInt(response.data.records[0].percentage_4, 10),
                    parseInt(response.data.records[0].percentage_3, 10),
                    parseInt(response.data.records[0].percentage_2, 10),
                    parseInt(response.data.records[0].percentage_1, 10)
                ]
            });
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    checkValues() {
        if (this.state.schoolSystemLimits.length > 0
        && (!parseInt(this.state.schoolSystemLimits[0], 10)
        || !parseInt(this.state.schoolSystemLimits[1], 10)
        || !parseInt(this.state.schoolSystemLimits[2], 10)
        || !parseInt(this.state.schoolSystemLimits[3], 10))) {
            this.setState({
                schoolSystemLimits: this.currentSchoolSystemLimits
            });
        }
        if (parseInt(this.state.schoolSystemLimits[0], 10) < 1) {
            let schoolSystemLimits = this.state.schoolSystemLimits;
            schoolSystemLimits[0] = 1;
            this.setState({
                schoolSystemLimits: schoolSystemLimits
            });
        }
        if (parseInt(this.state.schoolSystemLimits[1], 10) <= this.state.schoolSystemLimits[0]) {
            let schoolSystemLimits = this.state.schoolSystemLimits;
            schoolSystemLimits[1] = (this.state.schoolSystemLimits[0] + 1);
            this.setState({
                schoolSystemLimits: schoolSystemLimits
            });
        }
        if (parseInt(this.state.schoolSystemLimits[2], 10) <= this.state.schoolSystemLimits[1]) {
            let schoolSystemLimits = this.state.schoolSystemLimits;
            schoolSystemLimits[2] = (this.state.schoolSystemLimits[1] + 1);
            this.setState({
                schoolSystemLimits: schoolSystemLimits
            });
        }
        if (parseInt(this.state.schoolSystemLimits[3], 10) <= this.state.schoolSystemLimits[2]) {
            let schoolSystemLimits = this.state.schoolSystemLimits;
            schoolSystemLimits[3] = (this.state.schoolSystemLimits[2] + 1);
            this.setState({
                schoolSystemLimits: schoolSystemLimits
            });
        }
        if (parseInt(this.state.schoolSystemLimits[3], 10) > 100) {
            let schoolSystemLimits = this.state.schoolSystemLimits;
            schoolSystemLimits[3] = 100;
            this.setState({
                schoolSystemLimits: schoolSystemLimits
            });
        }
        if (parseInt(this.state.schoolSystemLimits[2], 10) >= this.state.schoolSystemLimits[3]) {
            let schoolSystemLimits = this.state.schoolSystemLimits;
            schoolSystemLimits[2] = (this.state.schoolSystemLimits[3] - 1);
            this.setState({
                schoolSystemLimits: schoolSystemLimits
            });
        }
        if (parseInt(this.state.schoolSystemLimits[1], 10) >= this.state.schoolSystemLimits[2]) {
            let schoolSystemLimits = this.state.schoolSystemLimits;
            schoolSystemLimits[1] = (this.state.schoolSystemLimits[2] - 1);
            this.setState({
                schoolSystemLimits: schoolSystemLimits
            });
        }
        if (parseInt(this.state.schoolSystemLimits[0], 10) >= this.state.schoolSystemLimits[1]) {
            let schoolSystemLimits = this.state.schoolSystemLimits;
            schoolSystemLimits[0] = (this.state.schoolSystemLimits[1] - 1);
            this.setState({
                schoolSystemLimits: schoolSystemLimits
            });
        }
    }

    handlePassedSystemSliderChange(e) {
        this.setState({
            passedSystemLimit: parseInt(e.target.value, 10)
        });
    }

    savePassedSystemLimit() {
        if (!parseInt(this.state.passedSystemLimit, 10)) {
            this.setState({
                passedSystemLimit: this.currentPassedSystemLimit
            });
        }
        if (parseInt(this.state.passedSystemLimit, 10) < 1) {
            this.setState({
                passedSystemLimit: 1
            });
        }
        if (parseInt(this.state.passedSystemLimit, 10) > 100) {
            this.setState({
                passedSystemLimit: 100
            });
        }
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.put(Globals.EL_PATH + "grading_system/passed_system?Authentication=" + cookie, {
            GRADING_1: "Bestanden",
            GRADING_2: "Nicht Bestanden",
            PERCENTAGE: this.state.passedSystemLimit
        }).then(response => {
            this.getPassedSystem();
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    getPassedSystemSaveButton() {
        if (this.currentPassedSystemLimit === this.state.passedSystemLimit) {
            return <button className="btn btn-info center-block margin-top-sm" disabled>Speichern</button>;
        } else {
            return <button className="btn btn-info center-block margin-top-sm" onClick={ () => this.savePassedSystemLimit() }>Speichern</button>;
        }
    }

    handleSchoolSystemLimitChange(e, index) {
        let schoolSystemLimits = this.state.schoolSystemLimits;
        schoolSystemLimits[index] = parseInt(e.target.value, 10);
        this.setState({
            schoolSystemLimits: schoolSystemLimits
        });
    }

    saveSchoolSystemLimits() {
        this.checkValues();
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.put(Globals.EL_PATH + "grading_system/percentage_system?Authentication=" + cookie, {
            GRADE_1: "Sehr Gut",
            GRADE_2: "Gut",
            GRADE_3: "Befriedigend",
            GRADE_4: "Genügend",
            GRADE_5: "Nicht Genügend",
            PERCENTAGE_1: this.state.schoolSystemLimits[3],
            PERCENTAGE_2: this.state.schoolSystemLimits[2],
            PERCENTAGE_3: this.state.schoolSystemLimits[1],
            PERCENTAGE_4: this.state.schoolSystemLimits[0]
        }).then(response => {
            this.getSchoolSystem();
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    saveAwardSystemLimits() {
        if (this.state.awardSystemLimits.length > 0
        && (!parseInt(this.state.awardSystemLimits[0], 10)
        || !parseInt(this.state.awardSystemLimits[1], 10)
        || !parseInt(this.state.awardSystemLimits[2], 10))) {
            this.setState({
                awardSystemLimits: this.currentAwardSystemLimits
            });
        } else {
            this.checkValues();
            let cookie = this.props.LogoutOnCookieNotSet();
            axios.put(Globals.EL_PATH + "grading_system/grading_passed_system?Authentication=" + cookie, {
                GRADE_1: "Sehr Guter Erfolg",
                GRADE_2: "Guter Erfolg",
                GRADE_3: "Erfolg",
                GRADE_4: "Nicht Bestanden",
                PERCENTAGE_1: this.state.awardSystemLimits[2],
                PERCENTAGE_2: this.state.awardSystemLimits[1],
                PERCENTAGE_3: this.state.awardSystemLimits[0]
            }).then(response => {
                this.getAwardSystem();
            }).catch(error => {
                this.props.CheckAuthError(error);
            });
        }
    }

    getSchoolSystemSaveButton() {
        if (this.state.schoolSystemLimits[0] === this.currentSchoolSystemLimits[0]
        && this.state.schoolSystemLimits[1] === this.currentSchoolSystemLimits[1]
        && this.state.schoolSystemLimits[2] === this.currentSchoolSystemLimits[2]
        && this.state.schoolSystemLimits[3] === this.currentSchoolSystemLimits[3]) {
            return <button className="btn btn-info center-block margin-top-sm" disabled>Speichern</button>;
        } else {
            return <button className="btn btn-info center-block margin-top-sm" onClick={ () => this.saveSchoolSystemLimits() }>Speichern</button>;
        }
    }

    getAwardSystemSaveButton() {
        if (this.state.awardSystemLimits[0] === this.currentAwardSystemLimits[0]
        && this.state.awardSystemLimits[1] === this.currentAwardSystemLimits[1]
        && this.state.awardSystemLimits[2] === this.currentAwardSystemLimits[2]) {
            return <button className="btn btn-info center-block margin-top-sm" disabled>Speichern</button>;
        } else {
            return <button className="btn btn-info center-block margin-top-sm" onClick={ () => this.saveAwardSystemLimits() }>Speichern</button>;
        }
    }

    handleAwardSystemLimitChange(e, index) {
        let awardSystemLimits = this.state.awardSystemLimits;
        awardSystemLimits[index] = parseInt(e.target.value, 10);
        this.setState({
            awardSystemLimits: awardSystemLimits
        });
    }

    renderSchoolSystem() {
        if (this.state.schoolSystemLimits.length !== 0) {
            return (
                <div className="panel-body">
                    <div className="clear-both gradeContainer">
                        <p className="float-left">Sehr Gut: <b>{">= " + this.state.schoolSystemLimits[3] }%</b></p>
                        <div className="fillSpacer">
                            <div className="slidecontainer float-right">
                                <input className="form-control" type="number" min='0' max="100" value={ this.state.schoolSystemLimits[3] } onChange={ (e) => this.handleSchoolSystemLimitChange(e, 3) }/>
                            </div>
                        </div>
                    </div>
                    <div className="clear-both gradeContainer">
                        <p className="float-left">Gut: <b>{">= " + this.state.schoolSystemLimits[2] }%</b></p>
                        <div className="fillSpacer">
                            <div className="slidecontainer float-right">
                                <input className="form-control" type="number" min='0' max='100' value={ this.state.schoolSystemLimits[2] } onChange={ (e) => this.handleSchoolSystemLimitChange(e, 2) }/>
                            </div>
                        </div>
                    </div>
                    <div className="clear-both gradeContainer">
                        <p className="float-left">Befriedigend: <b>{">= " + this.state.schoolSystemLimits[1] }%</b></p>
                        <div className="fillSpacer">
                            <div className="slidecontainer float-right">
                                <input className="form-control" type="number" min='0' max='100' value={ this.state.schoolSystemLimits[1] } onChange={ (e) => this.handleSchoolSystemLimitChange(e, 1) }/>
                            </div>
                        </div>
                    </div>
                    <div className="clear-both gradeContainer">
                        <p className="float-left">Genügend: <b>{">= " + this.state.schoolSystemLimits[0] }%</b></p>
                        <div className="fillSpacer">
                            <div className="slidecontainer float-right">
                                <input className="form-control" type="number" min="0" max="100" value={ this.state.schoolSystemLimits[0] } onChange={ (e) => this.handleSchoolSystemLimitChange(e, 0) }/>
                            </div>
                        </div>
                    </div>
                    <p>Nicht Genügend: <b> {"< " + this.state.schoolSystemLimits[0] }%</b></p>
                    { this.getSchoolSystemSaveButton() }
                </div>
            );
        } else {
            return (
                <div className="panel-body">
                    <div className="loader center-block no-margin-bottom"/>
                </div>
            );
        }
    }

    renderAwardSystem() {
        if (this.state.awardSystemLimits.length !== 0) {
            return (
                <div className="panel-body">
                    <div className="clear-both gradeContainer">
                        <p className="float-left">Sehr Guter Erfolg: <b>{">= " + this.state.awardSystemLimits[2] }%</b></p>
                        <div className="fillSpacer">
                            <div className="slidecontainer float-right">
                                <input className="form-control" type="number" min='0' max='100' value={ this.state.awardSystemLimits[2] } onChange={ (e) => this.handleAwardSystemLimitChange(e, 2) }/>
                            </div>
                        </div>
                    </div>
                    <div className="clear-both gradeContainer">
                        <p className="float-left">Guter Erfolg: <b>{">= " + this.state.awardSystemLimits[1] }%</b></p>
                        <div className="fillSpacer">
                            <div className="slidecontainer float-right">
                                <input className="form-control" type="number" min='0' max='100' value={ this.state.awardSystemLimits[1] } onChange={ (e) => this.handleAwardSystemLimitChange(e, 1) }/>
                            </div>
                        </div>
                    </div>
                    <div className="clear-both gradeContainer">
                        <p className="float-left">Erfolg: <b>{">= " + this.state.awardSystemLimits[0] }%</b></p>
                        <div className="fillSpacer">
                            <div className="slidecontainer float-right">
                                <input className="form-control" type="number" min="0" max="100" value={ this.state.awardSystemLimits[0] } onChange={ (e) => this.handleAwardSystemLimitChange(e, 0) }/>
                            </div>
                        </div>
                    </div>
                    <p>Nicht Bestanden: <b> {"< " + this.state.awardSystemLimits[0] }%</b></p>
                    { this.getAwardSystemSaveButton() }
                </div>
            );
        } else {
            return (
                <div className="panel-body">
                    <div className="loader center-block no-margin-bottom"/>
                </div>
            );
        }
    }

    render() {
        return (
            <div className="container gradingSystems">
                <h1 className="text-center margin-bottom-lg">Benotungssysteme</h1>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="text-center no-margin">Einfaches Benotungssystem</h3>
                    </div>
                    <div className="panel-body">
                        <label>Grenze von "Nicht Bestanden" zu "Bestanden"</label>
                        <p className="no-margin">Derzeitiger Wert: <b>{ this.currentPassedSystemLimit }%</b></p>
                        <p>Neuer Wert: <b>{ this.state.passedSystemLimit }%</b></p>
                        <div className="slidecontainer">
                            <input className="form-control" type="number" min="0" max="100" value={ this.state.passedSystemLimit } onChange={ (e) => this.handlePassedSystemSliderChange(e) }/>
                        </div>
                        { this.getPassedSystemSaveButton() }
                    </div>
                </div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="text-center no-margin">Benotungssystem mit Auszeichnung</h3>
                    </div>
                    { this.renderAwardSystem() }
                </div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="text-center no-margin">Schulnotensystem</h3>
                    </div>
                    { this.renderSchoolSystem() }
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/admin/GradingSystems.js